// extracted by mini-css-extract-plugin
export default {"headerImg":"_3hYbfkwX-Sh8sPi1czaGwt"};